import { useEffect, useState } from "react";
import { Grid, Divider, Typography, Skeleton } from "@mui/material";
import axios from "axios";
import AddClassToCard from "../../../functions/addClassToCard";
import { riepilogativoTentativiMediaChiamate } from "../../../const/CardDati";
import {
  CDCard,
  CDCardContent,
  CDCardHeader,
} from "../../../const/CDCardStyles";
import IconTooltip from "../Tooltip/Tooltip";
import { riepilogoTentativiMediaChiamateTexts } from "../../../const/CardTexts";
import { useDispatch } from 'react-redux';
import {notificationOpen}  from "../../../redux/reducers/notification-reducer";
import handlerError from "../../../functions/handlerError";

const isCorrectRangeData = true;
const urlBase = process.env.REACT_APP_URL;
const DateComponent = riepilogativoTentativiMediaChiamate;


const RiepilogoTentativiMediaChiamata = ({ refresh, dataPicker, deviceFilter }) => {
  const dispatch = useDispatch();
  const [isFetching, setIsFetching] = useState();
  const [datiCard, setDatiCard] = useState({});
  const { cTextName, icon, amount } = datiCard;

  useEffect(() => {
    (async () => {
      if (isCorrectRangeData) {
        setIsFetching(true);
        const { tipoChiamata, action, method } = DateComponent;
        const { startDate, endDate } = dataPicker;
        const body = {
          startDate,
          endDate,
          deviceId: deviceFilter
        };
        let url = urlBase + action;
        try {
          const response = await axios({
            method: method,
            url,
            data: body
          });

          const { data } = response;
          const { cName, cTextName, ChartType, icon, text, amount } = AddClassToCard(data, tipoChiamata); 
          setDatiCard({ cName, cTextName, ChartType, icon, text, amount });

        } catch(error){
          console.error(error);
          const notificationError = handlerError(error)
          dispatch(notificationOpen(notificationError))
        } 
        setIsFetching(false);
      }
    })();
  }, [refresh, dataPicker, deviceFilter]);


  return (
    <>
    <Grid item xs={12} md>
      <CDCard>
        {!isFetching ? (
          amount >= 0 && (
            <>
             <CDCardHeader 
              sx={{minWidth:"250px"}}
               title={
                <IconTooltip data={riepilogoTentativiMediaChiamateTexts} />
              } />
              <Divider />
              <CDCardContent>
                <Grid item>
                  <div className="call-item__description">
                    <span className={cTextName}></span>
                  </div>
                </Grid>
                <Grid container>
                  <Grid item xs={6} sm={6}>
                    <Typography variant="h4" className="summary-call-card-value">{amount}</Typography>
                  </Grid>
                  <Grid container item xs={6} sm={6} sx={{display:"flex", alignItems:"flex-end", justifyContent:"right" }}>
                    <Grid item>
                      <div className="call-item__amount">
                        <span>{icon}</span>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </CDCardContent>
            </>
          )
        ) : (
          <>          
              <CDCardHeader title={
                <IconTooltip data={riepilogoTentativiMediaChiamateTexts} />
              } />
              <Divider />
              <CDCardContent>
                <Grid item>
                  <div className="call-item__description">
                    <span className={cTextName}></span>
                  </div>
                </Grid>
                <Grid container>
                  <Grid item xs={6} sm={6}>
                   <Skeleton variant="rectangular" height={34}/>
                  </Grid>
                  <Grid container item xs={6} sm={6} sx={{display:"flex", alignItems:"flex-end", justifyContent:"center" }}>
                  <Grid item xs={12} sm={12}>
                    <div className="call-item__amount">
                      <span><Skeleton variant="rectangular" width={34} height={34} /></span>
                    </div>
                  </Grid>
                  </Grid>
                </Grid>
              </CDCardContent>
          </>
        )}
      </CDCard>
    </Grid>
  </>
  );
};

export default RiepilogoTentativiMediaChiamata;
